import { ensureMockAuthSession } from "@/features/auth/auth.mock";
import { workflowApi } from "@/features/workflow/workflow.api";
import { workflowKeys } from "@/features/workflow/workflow.hooks";
import { queryClient } from "@/shared/lib/queryClient";
import { createRoute, isRedirect, redirect } from "@tanstack/react-router";
import i18n from "i18next";
import { workflowRoute } from "../route";

export const workflowNewRoute = createRoute({
	getParentRoute: () => workflowRoute,
	path: "/new",
	beforeLoad: async () => {
		if (ensureMockAuthSession()) {
			throw redirect({ to: "/workflow/$id", params: { id: "mock" }, replace: true });
		}

		try {
			const workflow = await workflowApi.create({ name: i18n.t("workflow.defaultName") });
			queryClient.invalidateQueries({ queryKey: workflowKeys.all });
			throw redirect({ to: "/workflow/$id", params: { id: workflow.id }, replace: true });
		} catch (e) {
			if (isRedirect(e)) throw e;
			throw redirect({ to: "/workflow", replace: true });
		}
	},
});
